import ModalContentNotifications from 'library/molecules/ModalContentNotifications'
import Modal, {
  RecursiveOmitSetActiveModalId,
  ActiveModalProps,
  ModalConfig,
  MODAL_MIXINS
} from 'shared/library/molecules/Modal'
import styled from '@emotion/styled'
import useTranslation from 'next-translate/useTranslation'

export enum MODAL_IDS {
  notifications = 'notifications'
}

export type ModalProps = RecursiveOmitSetActiveModalId<{
  [MODAL_IDS.notifications]: Record<string, unknown>
}>

export const MODAL_CONFIG: ModalConfig = {
  [MODAL_IDS.notifications]: {
    id: MODAL_IDS.notifications,
    Content: ModalContentNotifications,
    clickOutsideToClose: true
  }
}

/**
 * Please refer to https://www.notion.so/eola/Modals-new-widget-d5a5b2c100c840878761cd28bb3279a2
 * for an explanation on our approach to Modals
 */
const HeaderModals = ({
  activeModal,
  setActiveModalId,
  ...props
}: Omit<ActiveModalProps, 'activeModalId'>) => {
  const { t } = useTranslation('common')

  const MODAL_TITLE = {
    [MODAL_IDS.notifications]: t('notifications')
  }

  const ModalContent = activeModal?.Content ? activeModal.Content : () => null
  const ModalTitle = activeModal?.id
    ? MODAL_TITLE[activeModal.id as keyof typeof MODAL_TITLE]
    : undefined
  const ModalOnClickOutside = activeModal?.clickOutsideToClose
    ? () => setActiveModalId(null)
    : undefined

  return (
    <StyledModal
      isOpen={!!activeModal}
      activeModalId={activeModal?.id}
      animationVariant="rightToLeftWithOverlay"
      fullWindow
      modalTitle={ModalTitle}
      onClickOutside={ModalOnClickOutside}
    >
      <ModalContent {...props} setActiveModalId={setActiveModalId} />
    </StyledModal>
  )
}

export default HeaderModals

const StyledModal = styled(Modal)(
  () => MODAL_MIXINS.stickToRight(),
  ({ theme, activeModalId }) =>
    activeModalId === 'notifications'
      ? {
          '[role="dialog"]': {
            right: 0,
            margin: 0,
            maxWidth: theme.contentMaxWidth.xs
          }
        }
      : {
          '[role="dialog"]': {
            margin: 'auto'
          }
        }
)
